import * as React from 'react'
import { IMap, IMembershipObject, IProviderProductObject, IRiderObject, IServiceObject } from '../../../../types'
import MembershipListItem from './MembershipListItem'
import { SERVICE_LIST_TYPE } from '../../../../state/constants/index'
import UIMessages from '../../../../utils/ui-messages'
import FloatingForm from 'src/components/ui/form/FloatingForm'

interface IMembershipPaneProps {
  memberships: IMembershipObject[]
  orgId: string
  providerProducts: IMap<IProviderProductObject>
  rider: IRiderObject
  riderId: string
  services: IMap<IServiceObject>
  getMembershipList: (riderId: string, orgId: string) => void
  getServiceList: (type: string, orgId: string) => void
  suspend: (membership: IMembershipObject) => void
}

interface IMembershipPaneState {
  memberships: IMembershipObject[]
}

class MembershipPane extends React.Component<IMembershipPaneProps, IMembershipPaneState> {
  constructor(props: any) {
    super(props)
    this.state = {
      memberships: this.props.memberships
    }
  }

  public componentDidMount() {
    this.props.getMembershipList(this.props.riderId, this.props.orgId)
    this.props.getServiceList(SERVICE_LIST_TYPE.ACTIVE, this.props.orgId)
  }

  public render() {
    const memberships = this.props.memberships ? Object.values(this.props.memberships) : []
    return (
      <section>
        <FloatingForm fullHeight={true}>
          <div className='form-modal-section main-section'>
            <div>
              {memberships.length &&
                memberships.map((item: IMembershipObject, i) => {
                  return (
                    <div className={'MembershipItem' + i} key={`tmli-${i}`}>
                      <MembershipListItem
                        membership={item}
                        providerProducts={this.props.providerProducts}
                        service={item.service ? item.service : ({} as IServiceObject)}
                        suspend={this.props.suspend}
                      />
                    </div>
                  )
                })}
            </div>
          </div>
          <div style={{ flex: 1 }}>&nbsp;</div>
        </FloatingForm>
      </section>
    )
  }
}

export default MembershipPane



// WEBPACK FOOTER //
// ./src/components/riders/riderdetails/membership/MembershipPane.tsx